import React, { useState } from "react";
import ApiClient from "ApiClient";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ErrorList from "Components/ErrorList";
import { toast } from "react-toastify";
import Routes from "Components/Routes";
import { NavLink } from "react-router-dom";

function ContactForm() {
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [message, setMessage] = useState("");
  const [isSending, setIsSending] = useState(false);
  const [sentSuccessfully, setSentSuccessfully] = useState(false);

  function onFormSubmit(e) {
    e.preventDefault();
    if (isSending === true) {
      return;
    }

    setIsSending(true);
    toast.dismiss();

    ApiClient.post("Contact", {
      Email: email,
      Subject: subject,
      Message: message,
    })
      .then((res) => {
        setEmail("");
        setMessage("");
        setSubject("");
        setSentSuccessfully(true);
      })
      .catch((res) => {
        if (res != null && res.response != null && res.response.data != null && res.response.data.errors != null) {
          let errors = [];
          for (let k in res.response.data.errors) {
            errors.push(res.response.data.errors[k][0]);
          }

          toast.error(<ErrorList listClass="list-unstyled p-0 mb-1" errors={errors}></ErrorList>);
        } else {
          toast.error("We could not send the email at this moment. Please try again later.");
        }
      })
      .finally(() => {
        setIsSending(false);
      });
  }
  return (
    <div className="row mt-4">
      <div className="text-center col-12">
        <h1 className="h2">Contact us</h1>
        <p>We would be happy to hear any feedback or suggestions you may have.</p>
      </div>

      <div className="col-12 mt-4">
        <div className="mx-auto" style={{ maxWidth: "600px" }}>
          {sentSuccessfully === false ? (
            <form onSubmit={onFormSubmit}>
              <div className="form-group">
                <label htmlFor="Email">
                  Email <span className="required">*</span>
                </label>
                <input onChange={(e) => setEmail(e.target.value)} value={email} required type="email" name="Email" className="form-control"></input>
              </div>

              <div className="form-group">
                <label htmlFor="Subject">
                  Subject <span className="required">*</span>
                </label>
                <input onChange={(e) => setSubject(e.target.value)} value={subject} required name="Subject" className="form-control"></input>
              </div>

              <div className="form-group">
                <label htmlFor="Message">
                  Message <span className="required">*</span>
                </label>
                <textarea onChange={(e) => setMessage(e.target.value)} value={message} required style={{ minHeight: "300px" }} name="Message" className="form-control"></textarea>
              </div>

              <div className="form-group">
                <button type="submit" className="btn btn-primary">
                  {isSending === true && (
                    <i>
                      <FontAwesomeIcon icon="circle-notch" className="fa-spin"></FontAwesomeIcon>
                    </i>
                  )}{" "}
                  Send
                </button>
              </div>
            </form>
          ) : (
            <div className="text-center">
              <div className="alert-success alert">We have received your email and we will reply back to you as soon as possible.</div>
              <NavLink to={Routes.home}>
                <FontAwesomeIcon icon="arrow-left"></FontAwesomeIcon> back
              </NavLink>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ContactForm;
